<template>
  <a-tabs type="card" id="client">
    <a-tab-pane tab="合同管理" key="1">
      <a-row class="row-content" type="flex" justify="space-between" align="middle">
        <a-col class="col">
          <span class="title">{{ name }}的合同管理</span>
        </a-col>
        <a-col class="col">
          <a-button size="large" class="screen" type="primary" @click="operateStaff()">+添加合同</a-button>
        </a-col>
      </a-row>
      <a-row type="flex" align="middle" justify="start" class="sort-bar">
        <template v-for="sort in sorts">
          <a-col span="3" class="sort" :key="sort.id">
            {{ sort.name }}
            <a-icon :type="`arrow-${sort.arr}`"></a-icon>
          </a-col>
        </template>
      </a-row>
      <a-spin :spinning="loading" size="large">
        <ul class="data-list">
          <template v-for="(item, index) in listData">
            <li class="list" :key="index">
              <a-row class="row" type="flex" justify="space-between">
                <a-col class="content">
                  <div>
                    合同类型：
                    {{
                    item.type == "FLASH_INTERVIEW"
                    ? "闪面试"
                    : item.type == "TRIAL_ORDER"
                    ? "试单"
                    : item.type == "ENTRY"
                    ? "入职"
                    : null
                    }}
                  </div>
                  <div>合同ID: {{ item.id }}</div>
                  <div>合同甲方：{{ item.parta_person_name }}</div>
                  <div>合同乙方：{{ item.partb_person_name }}</div>
                </a-col>
                <a-col class="content">
                  <div>
                    合同周期：{{ item.start_date }} — {{ item.end_date }}
                    <span
                      :class="[
                        new Date(item.end_date).getTime() > new Date().getTime()
                          ? 'green'
                          : 'red'
                      ]"
                    >（有效）</span>
                  </div>
                  <div>合同ID: {{item.id}}</div>
                  <div>合同甲方：{{item.parta_person_name}}</div>
                  <div>合同乙方：{{item.partb_person_name}}</div>
                </a-col>
                <a-col class="content">
                  <div>合同名称：{{item.name}}</div>
                  <div>
                    合同周期：{{item.start_date}} — {{item.end_date}}
                    <span
                      v-if="new Date(item.end_date).getTime()>new Date().getTime()"
                      class="green"
                    >（有效）</span>
                    <span
                      v-if="new Date(item.end_date).getTime()<new Date().getTime()"
                      class="red"
                    >（无效）</span>
                  </div>

                  <div>备注：{{item.remark}}</div>
                </a-col>
                <a-col class="content">
                  <div>添加时间：{{item.created_at}}</div>
                  <div>添加人：{{item.user_name}}</div>
                </a-col>
                <a-col class="content">
                  <a
                    style="textDecoration: underline"
                    @click="searchContract(item.attachment_url)"
                  >{{item.attachment_name?item.attachment_name:item.attachment}}</a>
                </a-col>
                <a-col class="contentEdit">
                  <div class="edit" @click="operateStaff(item)">编辑</div>
                </a-col>
              </a-row>
            </li>
          </template>
        </ul>
        <div style="margin-top: 50px;text-align: center" v-show="total==0">暂无数据</div>
      </a-spin>
      <Pagination ref="pagination" :total="total" @change="getList" v-show="total!=0"></Pagination>
      <EditContract ref="ContractModal" :getList="getList"></EditContract>
    </a-tab-pane>
  </a-tabs>
</template>

<script>
import Api from "@/api";
import EditContract from "./editContract";
import Pagination from "./Pagination";
const sorts = [
  {
    name: "合同信息",
    id: 0
  },
  {
    name: "签约信息",
    id: 1
  },
  {
    name: "添加信息",
    id: 2
  },
  {
    name: "合同附件",
    id: 3
  },
  {
    name: "操作",
    id: 4
  }
];
export default {
  name: "contract",
  data() {
    return {
      sorts,
      listData: [],
      name: undefined,
      post_id: undefined,
      pagination: undefined,
      total: "0",
      loading: false
    };
  },
  created() {
    this.post_id = Number(this.$route.query.id);
    this.name = this.$route.query.name;
  },
  mounted() {
    this.pagination = this.$refs.pagination;
    this.getList();
  },
  methods: {
    searchContract(fileurl) {
      window.open(fileurl, "_blank");
    },
    async getList(pagination) {
      this.loading = true;
      let params = {
        company_id: this.post_id,
        page: this.pagination.current,
        limit: this.pagination.pageSize
      };
      if (pagination) {
        params.page = pagination.current;
        params.limit = pagination.pageSize;
      }
      let res = await Api.client.getContract(params);
      console.log(new Date());

      this.loading = false;
      this.listData = res.list;
      this.total = res.total;
    },
    operateStaff(item) {
      let { ContractModal } = this.$refs;
      if (item) {
        ContractModal.type = "edit";
        console.log(item);
        ContractModal.show(item, this.post_id);
      } else {
        console.log("123");
        ContractModal.type = "add";
        ContractModal.show(this.post_id);
      }
    }
  },
  components: { Pagination, EditContract }
};
</script>

<style scoped lang="scss">
#client {
  .green {
    color: green;
  }
  .red {
    color: red;
  }
  .title {
    font-size: 15px;
    font-weight: bold;
  }
  .screen {
    border-radius: 4px;
    font-weight: bold;
  }
  .sort-bar {
    text-align: center;
    margin-top: 20px;
    border-radius: 3px;
    background: #35b5fe;
    border: 1px solid rgba(228, 232, 235, 1);
    .sort {
      width: 20%;
      font-size: 16px;
      height: 58px;
      line-height: 58px;
      font-weight: bold;
      color: #ffffff;
      &.active {
        color: #35b5fe;
      }
    }
  }
  .data-list {
    padding-left: 0;
    li {
      list-style: none;
      // cursor: pointer;
      margin-top: 11px;
      border-radius: 3px;
      border: 1px solid rgba(228, 232, 235, 1);
      position: relative;
      padding: 18px 32px 20px 40px;
      &:hover {
        background: #f5f7fa;
      }
      img.shang {
        position: absolute;
        left: 0;
        top: 0;
        width: 35px;
      }
      .row {
        &.row2 {
          padding-top: 10px;
        }
        .col {
          display: flex;
          align-items: center;
          &.gap {
            span:not(:last-child) {
              margin-right: 16px;
            }
          }
          span {
            display: inline-block;
            &.title {
              font-size: 16px;
              font-weight: bold;
            }
            &.ji {
              font-size: 12px;
              background: #ff6b5d;
              border-radius: 2px;
              height: 18px;
              color: #fff;
              padding: 0 3px;
            }
            &.hc {
              background: #f6b502;
              padding: 0 3px;
              font-size: 12px;
              border-radius: 2px;
              height: 18px;
              color: #fff;
            }
            &.time {
              color: #999;
            }
            &.salary {
              font-size: 16px;
              color: #fc5646;
            }
            .anticon {
              font-size: 18px;
              margin-right: 5px;
            }
          }
          a {
            display: inline-block;
            margin-left: 20px;
            img {
              margin-right: 5px;
            }
          }
          .ant-btn {
            margin-left: 20px;
          }
        }
      }
    }
  }
  .list {
    min-height: 160px;
    .content {
      width: 22%;
      & > div {
        margin-bottom: 10px;
      }
      .company {
        font-size: 16px;
        font-weight: 400;
        margin-right: 10px;
      }
    }
    .contentEdit {
      width: 12%;
      padding-right: 7%;
      border-left: 1px solid #dddddd;
      .edit {
        text-align: center;
        margin-left: 70%;
        margin-top: 40px;
        width: 80px;
        height: 40px;
        border-radius: 4px;
        line-height: 40px;
        background: #35b5fe;
        color: #ffffff;
        cursor: pointer;
      }
    }
  }
  .ant-pagination {
    text-align: right;
  }
}
</style>
